{
  "generic": {
    "no": "Nem",
    "yes": "Igen",
    "text": "Szöveg "
  },
  "consent": {
    "defaultLabelText": "A jelen űrlap elküldésével elfogadja ",
    "defaultLabelLink": "adatvédelmi irányelvek"
  },
  "text": {
    "defaultHeadlineText": "Ez egy címsor",
    "defaultText": "Ez egy szövegblokk",
    "floatingDefaultText": "ÚJ!"
  },
  "button": {
    "submitDefaultText": "Küldés",
    "instagramDefaultText": "Kövess minket",
    "defaultText": "Kattintson ide",
    "closing": "ZÁRÁS..."
  },
  "input": {
    "emailLabel": "E-mail",
    "emailPlaceholder": "Adja meg e-mail címét",
    "passwordLabel": "Jelszó",
    "passwordPlaceholder": "Adja meg a jelszót",
    "nameLabel": "Név",
    "namePlaceholder": "Adja meg nevét",
    "firstNameLabel": "Keresztnév",
    "firstNamePlaceholder": "Adja meg keresztnevét",
    "lastNameLabel": "Vezetéknév",
    "lastNamePlaceholder": "Adja meg vezetéknevét",
    "phoneLabel": "Telefon",
    "phonePlaceholder": "Adja meg telefonszámát",
    "textareaLabel": "Üzenet",
    "textareaPlaceholder": "Adja meg üzenetét",
    "regularLabel": "Szöveg",
    "regularPlaceholder": "Adja meg a szöveget",
    "defaultLabel": "Címke",
    "defaultPlaceholder": "Helykitöltő",
    "datePlaceholder": "Válasszon dátumot",
    "stepLabel": "Adja meg kérdését itt"
  },
  "dropdown": {
    "placeholder": "Válasszon egy lehetőséget",
    "firstItem": "1. lehetőség",
    "secondItem": "2. lehetőség",
    "chooseCountry": "Ország"
  },
  "buttonList": {
    "firstItem": "1. lehetőség",
    "secondItem": "2. lehetőség",
    "option1": "1. választás",
    "option2": "2. választás",
    "option3": "3. választás",
    "subscriptionItem1": "Hírlevél",
    "subscriptionItem2": "Frissítések",
    "chooseSubscriptionTopics": "Válasszon feliratkozási témákat",
    "other": "Egyéb",
    "uncheck-all-label": "Nem kívánok ilyen e-maileket kapni"
  },
  "rating": {
    "rateLabel": "Értékeljen minket",
    "npsLabel": "Mennyire valószínű, hogy ajánlani fog minket?",
    "veryUnsatisfied": "Nagyon elégedetlen",
    "unsatisfied": "Elégedetlen",
    "neutral": "Semleges",
    "satisfied": "Elégedett",
    "loveIt": "Imádom!",
    "minValueLabel": "Alacsony",
    "maxValueLabel": "Magas",
    "minValueLabelNps": "Nem valószínű",
    "maxValueLabelNps": "Nagyon valószínű"
  },
  "deadline": {
    "days": "Napok",
    "hours": "Órák",
    "minutes": "Percek",
    "seconds": "Másodpercek"
  },
  "bulletList": {
    "firstItem": "Előny 1",
    "secondItem": "Előny 2"
  },
  "discountCode": {
    "copyMessage": "Vágólapra másolva!",
    "fallback": "WELCOME10",
    "textDefault": "Az Ön kedvezménykódja",
    "buttonDefault": "Másolás"
  },
  "share": {
    "buttonText": "Megosztás"
  },
  "common": {
    "label": "Címke"
  },
  "wcag": {
    "banner": "Promóciós banner",
    "closeButton": "Bezárás",
    "submitButton": "Űrlap beküldése"
  },
  "spinTheWheel": {
    "prizeWonText": "Gratulálunk!",
    "prizeWonButtonText": "Igényelje nyereményét",
    "prizeLostText": "Jaj, milyen kár! :-(",
    "prizeLostButtonText": "Kattintson a bezáráshoz",
    "spinButtonLabel": "PÖRGÉS"
  },
  "memory": {
    "resultWonText": "Jó munka! Az ideje {elapsedTime} volt",
    "resultWonButtonText": "Igényelje nyereményét"
  },
  "stepNavigation": {
    "nextButtonText": "Tovább",
    "previousButtonText": "Vissza",
    "lastButtonText": "Bezárás",
    "submitButtonText": "Küldés"
  },
  "defaultRealTimeMessage": {
    "validationError": "Kérjük, ellenőrizze az elküldött adatok formátumát.",
    "unknownError": "Váratlan hiba történt az elküldés során.",
    "conflictError": "Ez a felhasználó már létezik.",
    "success": "Űrlap elküldve."
  }
}
